import React from 'react';
import { get } from 'lodash';
import HomepageBL from '../../homepage/HomepageBL';
import NumberUtils from '../../../utils/NumberUtils';

const isRegularSaver = (accountDetails) =>
  accountDetails?.product?.code === '760' ||
  accountDetails?.product?.code === '632';

const isRegularSaverWithInterest = (accountDetails) =>
  accountDetails?.product?.code === '632';

export const AccountSummaryText = ({
  account,
  accountInterestRegularSaverText = '',
}) => {
  /**
   * Summary Text for Current Accounts
   */
  if (
    account.type === 'current' &&
    get(account, 'accountDetails.overDraft') > 0
  ) {
    const overdraft = HomepageBL.shouldShowAvailableBalance(account)
      ? `Including ${NumberUtils.appendCurrency(
          '{}',
          account.accountDetails.overDraft
        )} overdraft`
      : `${NumberUtils.appendCurrency(
          '{}',
          account.accountDetails.overDraft
        )} arranged overdraft`;
    return <div className="cardsticky__hide">{overdraft}</div>;
  }

  /**
   * Summary Text for Savings accounts
   */

  if (
    account.type === 'savings' &&
    // assert that `interest_rate` is a number as 0 is falsey in JavaScript.
    typeof get(account, 'accountDetails.interest_rate') === 'number'
  ) {
    return isRegularSaver(account) ? (
      /**
       * Unlike other savings accounts. Don't content without "hiding" until the "More" button is clicked.
       *
       * Reg saver 632 returns an api interest_rate + different text. Whereas 760 is hardcoded.
       * Should look to have all new reg saver product setups be dynamic to interest_rate to avoid hardcoding
       */
      <div>
        {isRegularSaverWithInterest(account) &&
          `${account.accountDetails.interest_rate}% AER. `}

        {accountInterestRegularSaverText}
      </div>
    ) : (
      <div className="cardsticky__hide">
        {`Savings interest rate ${account.accountDetails.interest_rate}% AER.`}
      </div>
    );
  }

  /**
   * Summary Text for Credit Cards
   */
  if (
    account.type === 'credit_card' &&
    account.accountDetails &&
    !account.accountDetails.error
  ) {
    const creditMessage = `Based on your credit limit of ${NumberUtils.appendCurrency(
      '{}',
      account.accountDetails.creditLimit
    )}`;
    return account.accountDetails.creditLimit ? (
      <div className="cardsticky__hide">{creditMessage}</div>
    ) : null;
  }

  return null;
};
